import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMenuStore = defineStore('menuStore', () => {
    const isPrimaryMenuOpen = ref(false);
    const isUserDropdownMenuOpen = ref(false);

    const showPrimaryMenuChanged = (isOpen: boolean) => {
        isPrimaryMenuOpen.value = isOpen;
    };

    const showUserDropdownMenuChanged = (isOpen: boolean) => {
        isUserDropdownMenuOpen.value = isOpen;
    };

    return {
        isPrimaryMenuOpen,
        isUserDropdownMenuOpen,
        showPrimaryMenuChanged,
        showUserDropdownMenuChanged
    };
});
